import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'

// Connects to data-controller="rule-select"
export default class extends Controller {
  static targets = ["ruleType", "triggerName"]

  change(event) {
    event.preventDefault();

    const query = new URLSearchParams();

    // The form renders the rule type select only for a new rule, so this target is absent
    // on the edit form. An unguarded read raises there, which loses the trigger change and
    // every option that depends on it.
    if (this.hasRuleTypeTarget) {
      query.set("rule_type", this.ruleTypeTarget.value)
    }

    if (this.hasTriggerNameTarget) {
      query.set("trigger_name", this.triggerNameTarget.value)
    }

    window.location.href = `?${query}`;
  }
}
